<template>
  <section id="about" class="about">
    <div>
      <div class="section-title">
        <h2>論文、著作、發明(Publicaiton)</h2>
      </div>
      <hr />
      <h2 class="publicaiton-title">A. Journal Papers (SCI/SCIE/EI):</h2>
      <hr />
      <p
        class="certifications-content"
        v-for="item1 in journal"
        :key="item1.num"
      >
        <a class="ct1">{{ item1.num }}</a>
        <a class="ct2">{{ item1.name }}</a>
        <a
          v-if="item1.path != ''"
          class="ct3"
          :href="item1.path"
          target="_blank"
          ><u>{{ item1.ca }}</u></a
        >
        <a v-else class="ct3"> {{ item1.ca }}</a>
        <a class="ct4">{{ item1.num2 }}</a>
        <a class="ct5">{{ item1.cal }}</a>
      </p>
      <hr />
      <h2 class="publicaiton-title">B. Books:</h2>
      <hr />
      <p class="certifications-content" v-for="item1 in book" :key="item1.num">
        <a class="ct1">{{ item1.num }}</a>
        <a class="ct2" :href="item1.path" target="_blank"
          ><u>{{ item1.name }}</u></a
        >
        <a class="ct3">{{ item1.ca }}</a>
        <a class="ct4">{{ item1.num2 }}</a>
        <a class="ct5">{{ item1.cal }}</a>
      </p>
      <hr />
      <h2 class="publicaiton-title">C. Patents:</h2>
      <hr />
      <p
        class="certifications-content"
        v-for="item1 in patents"
        :key="item1.num"
      >
        <a class="ct1">{{ item1.num }}</a>
        <a
          v-if="item1.path != ''"
          class="ct2"
          :href="item1.path"
          target="_blank"
          ><u>{{ item1.name }}</u></a
        >
        <a v-else class="ct2"> {{ item1.name }}</a>
        <a class="ct3">{{ item1.ca }}</a>
        <a class="ct4">{{ item1.num2 }}</a>
        <a class="ct5">{{ item1.cal }}</a>
      </p>
      <hr />
      <h2 class="publicaiton-title">D. International Conference Papers:</h2>
      <hr />
      <p
        class="certifications-content"
        v-for="item1 in International_conference"
        :key="item1.num"
      >
        <a class="ct1">{{ item1.num }}</a>
        <a class="ct2">{{ item1.name }}</a>
        <a
          v-if="item1.path != ''"
          class="ct3"
          :href="item1.path"
          target="_blank"
          ><u>{{ item1.ca }}</u></a
        >
        <a v-else class="ct3"> {{ item1.ca }}</a>
        <a
          v-if="item1.path2 != ''"
          class="ct4"
          :href="item1.path2"
          target="_blank"
          ><u>{{ item1.num2 }}</u></a
        >
        <a v-else class="ct4"> {{ item1.num2 }}</a>
        <a class="ct5">{{ item1.cal }}</a>
      </p>
      <hr />
      <h2 class="publicaiton-title">E.Other Conference Papers:</h2>
      <hr />
      <p
        class="certifications-content"
        v-for="item1 in other_conference"
        :key="item1.num"
      >
        <a class="ct1">{{ item1.num }}</a>
        <a class="ct2">{{ item1.name }}</a>
        <a class="ct3">{{ item1.ca }}</a>
        <a class="ct4">{{ item1.num2 }}</a>
        <a class="ct5">{{ item1.cal }}</a>
      </p>
    </div>
  </section>
</template>

<script>
import { publication_path } from "../assets/publicationRouter/publication";
var Indexbook = -1;
export default {
  name: "publication",
  data() {
    return {
      journal: [
        {
          num: "(J26).",
          name: "Ming-Te Chen and Tsung-Hung Lin* (2021),",
          ca: "“A Provable and Secure Patient Electronic Health Record Fair Exchange Scheme for Health Information Systems.”",
          num2: ", Applied Sciences (ISSN: 2076-3417), vol.11, no:5(2401), pp.1-20, 8 March 2021.",
          cal: "(SCIe, 2019 IF=2.474, CiteScore Ranking=85/299 (Q2) in “General Engineering”) (DOI:10.3390/app11052401) (Times cited:0)",
          path: "https://www.mdpi.com/2076-3417/11/5/2401",
        },

        {
          num: "(J25).",
          name: "Tsung-Hung Lin* and Kuan-Han Chen (2021),",
          ca: "“An efficient adaptive key agreement scheme for IIoT cyber security authentication using PUF circuit features.”",
          num2: ", International Journal of Computer, Consumer and Control(IJ3C)",
          cal: "(Print ISSN: 2304-2516, Online ISSN: 2304-2524), vol.10, no:1, pp.1-13, April 2021. (DOI:) (Times cited:0)",
          path: "http://ij3c.ncuteecs.org/volume/10-1.php",
        },

        {
          num: "(J24).",
          name: "Ming-Te Chen, Chia-Chu Chen, and Tsung-Hung Lin* (2020),",
          ca: "“A Cryptanalysis of Trustworthy Electronicvoting using Adjusted Blockchain Technology.“",
          num2: ", ICMHI 2020: Proceedings of the 4th International Conference on Medical and Health Informatics, Kamakura City, Japan, August 2020.",
          cal: "(ACM ICPS Proceeding ISBN: 978-1-4503-7776-8)(https://doi.org/10.1145/3418094.3418143)(Ei Compendex, Scopes and Thomson Reuters Conference Proceedings Citation Index (ISI Web of Science))",
          path: "https://dl.acm.org/doi/10.1145/3418094.3418143",
        },

        {
          num: "(J23).",
          name: "Tsung-Hung Lin* and Ming-Te Chen (2020),",
          ca: "“An integrated two-stage medical pre-checkup and subsequent validation key agreement authentication mechanism”",
          num2: ", Applied Sciences (ISSN: 2076-3417), vol.10, no:5(1888), pp.1-14, 10 March 2020.",
          cal: "(SCIe, 2018 IF=2.217, CiteScore Ranking=41/275 (Q1) in “General Engineering”) (DOI:10.3390/app10051888) (Times cited:0)",
          path: "https://www.mdpi.com/2076-3417/10/5/1888",
        },

        {
          num: "(J22).",
          name: "Chwei-Shyong Tsai, Qi-Xian Huang, Tsung-Hung Lin, and Tian-Fu Lee (2019),",
          ca: "“Computation-Efficient Three-Party Encrypted Key Exchange for Telecare Medicine Information Systems.“",
          num2: ", ICMHI 2019: Proceedings of the third International Conference on Medical and Health Informatics 2019, pp.161-171, Xiamen, China, May 17~19, 2019.",
          cal: "(ACM ICPS Proceeding ISBN: 978-1-4503-7199-5) (https://doi.org/10.1145/3340037.3340064) (Ei Compendex, Scopes and Thomson Reuters Conference Proceedings Citation Index (ISI Web of Science))",
          path: "https://dl.acm.org/doi/10.1145/3340037.3340064",
        },

        {
          num: "(J21).",
          name: "Tsung-Hung Lin, Cheng-Chi Lee, and Chia-Hao Chang (2018),",
          ca: "“WSN integrated authentication schemes based on Internet of Things”, Journal of Internet Technology",
          num2: "(ISSN: 1607-9264), vol.19, no:4, pp.1043-1053, Jul. 2018.",
          cal: "(SCIe, 2017 IF=1.301, ISI JCR Ranking=66/87=0.75 (TELECOMMUNICATIONS)) (DOI: 10.3966/160792642018081904008) (Times cited:4)",
          path: "https://www.webofscience.com/wos/woscc/full-record/WOS:000441139700008",
        },

        {
          num: "(J20).",
          name: "Tsung-Hung Lin, Chen-Kun Tsung, Tian-Fu Lee, and Zeng-Bo Wang (2017),",
          ca: "“A Round-Efficient Authenticated Key Agreement Scheme Based on Extended Chaotic Maps for Group Cloud Meeting”",
          num2: ", Sensors (ISSN:1424-8220), Vol.17, no:12:2793, pp.1-14, 2017.",
          cal: "(SCIe, 2016 IF=2.677, ISI JCR Ranking=25/76=0.329) (DOI:10.3390/s17122793) (Times cited:2)",
          path: "https://www.webofscience.com/wos/woscc/full-record/WOS:000423285800093",
        },

        {
          num: "(J19).",
          name: "Tian-Fu Lee, Chia-Hung Hsiao, Si-Han Hwang, and Tsung-Hung Lin* (2017),",
          ca: "“Enhanced smartcard-based password-authenticated key agreement using extended chaotic maps”",
          num2: ", PLOS ONE (ISSN:1932-6203), vol.12, Issue:7, 12(7):e0181744, pp.1-20, July 31, 2017.",
          cal: "(SCIe, 2016 IF=2.806, ISI JCR Ranking=15/64=0.234 (Multidisciplinary Sciences-SCIE) (DOI: 10.1371/journal.pone.0181744).(Times cited:3)",
          path: "https://www.webofscience.com/wos/woscc/basic-search",
        },

        {
          num: "(J18).",
          name: "I-Pin Chang, Tian-Fu Lee, Tsung-Hung Lin, and Chuan-Ming Liu (2015),",
          ca: "“Enhanced Two-Factor Authentication and Key Agreement Using Dynamic Identities in Wireless Sensor Networks”",
          num2: ", Sensors (ISSN: 1424-8220), vol.15, no.12, pp.29841-29854, Dec. 2015.",
          cal: "(SCIe, 2014 IF=2.245, ISI JCR Ranking=31/74=0.419) (DOI: 10.3390/s151229767) (Times Cited: 27)",
          path: "https://www.webofscience.com/wos/woscc/full-record/WOS:000367539100005",
        },

        {
          num: "(J17).",
          name: "Der-Chyuan Lou, Tian-Fu Lee, and Tsung-Hung Lin (2015),",
          ca: "“Efficient biometric authenticated key agreements based on extended chaotic maps for telecare medicine information systems”",
          num2: ",  Journal of Medical Systems(Print ISSN: 0148-5598, Electronic version ISSN: 1573-689X), Vol.39, Issue 5, Article:58, pp.1-10, March 2015.",
          cal: "(SCIe, 2014 IF = 2.213, ISI JCR Ranking = 7/24 = 0.292 (MEDICAL INFORMATICS)) (DOI:10.1007/s10916-015-0240-4) (Times Cited: 7)",
          path: "https://www.webofscience.com/wos/woscc/full-record/WOS:000352821900017",
        },

        {
          num: "(J16).",
          name: "Tsung-Hung Lin and Tian-Fu Lee (2014),",
          ca: "“Secure Verifier-Based Three-Party Authentication Schemes without Server Public Keys for Data Exchange in Telecare Medicine Information Systems”",
          num2: ", Journal of Medical Systems (Print ISSN: 0148-5598, Electronic version ISSN: 1573-689X), Vol.38, Issue 5, Article:30, pp.1-9, May 2014.",
          cal: "(SCIe, 2014 IF = 2.213, JCR Ranking = 7/24 = 0.292 (MEDICAL INFORMATICS)) (DOI:10.1007/s10916-014-0030-4) (Times Cited: 11)",
          path: "https://link.springer.com/article/10.1007/s10916-014-0030-4",
        },

        {
          num: "(J15).",
          name: "Po-Ying Chen, Chi-Chang Chen, Wen-Kuan Yeh, …, Tsung-Hung Lin, and Shyh-Chang Liu (2014),",
          ca: "“Using Capacitance Sensor to Extract Characteristic Signals of Dozing from Skin Surface”",
          num2: ",  Journal of Sensors (Print ISSN: 1687-725X, Online ISSN:1687-7268), Vol.2014, Article:238350, pp.1-7, 13 Nov. 2014.",
          cal: "(SCIe, 2014 IF = 1.182, JCR Ranking = 130/249 = 0.522 (Engineering, Electrical and Electronic)) (DOI: 10.1155/2014/238350) (Times cited:1)",
          path: "https://www.hindawi.com/journals/js/2014/238350/",
        },

        {
          num: "(J14).",
          name: "Tian-Fu Lee, I-Pin Chang, Tsung-Hung Lin, and Ching-Cheng Wang (2013),",
          ca: "“A Secure and Efficient Password-Based User Authentication Scheme Using Smart Cards for the Integrated EPR Information System”",
          num2: ",  Journal of Medical Systems (Print ISSN: 0148-5598, Electronic version ISSN: 1573-689X), Vol.37, Issue 3, Article:9941, pp. 1-7, June 2013.",
          cal: "(SCIe, 2012 IF=1.783, JCR Ranking=36/83 (Health Care Sciences & Services)) (DOI:10.1007/s10916-013-9941-8) (Times Cited: 20)",
          path: "https://link.springer.com/article/10.1007/s10916-013-9941-8",
        },

        {
          num: "(J13).",
          name: "Cheng-Chi Lee, Tsung-Hung Lin, and Chwei-Shyong Tsai (2012),",
          ca: "“Cryptanalysis of a secure and efficient authentication protocol for anonymous channel in wireless communications”",
          num2: ",  Security and Communication Networks (Print ISSN: 1939-0114, online ISSN: 1939-0122), Vol. 5, Issue 12, pp. 1375-1378, Dec. 2012.",
          cal: "(SCIe, 2011 IF=0.414, ISI Journal Citation Reports © JCR Ranking: 2011: 112/135 (Computer Science Information Systems)) (DOI: 10.1002/sec.430) (Times Cited: 3)",
          path: "https://onlinelibrary.wiley.com/doi/abs/10.1002/sec.430",
        },

        {
          num: "(J12).",
          name: "Cheng-Chi Lee, Tsung-Hung Lin, and Rui-Xiang Chang (2011),",
          ca: "“A Secure Dynamic ID Based Remote User Authentication Scheme for Multi-server Environment using Smart Cards”",
          num2: ",  Expert Systems with Applications (ISSN: 0957-4174), Vol. 38, Issue 11, pp. 13863-13870, Oct. 2011.",
          cal: "(SCIe, 2010 IF=1.926, JCR Ranking=34/108=0.315 (Computer Science)) (DOI:10.1016/j.eswa.2011.04.190) (Times Cited: 140)",
          path: "https://www.sciencedirect.com/science/article/pii/S0957417411007172",
        },

        {
          num: "(J11).",
          name: "Tsung-Hung Lin, Cheng-Chi Lee, Chwei-Shyong Tsai, and Shin-Dong Guo (2010),",
          ca: "“A Tabular Steganography Scheme for Graphical Password Authentication”",
          num2: ", Computer Science and Information Systems (ISSN: 1820-0214), Vol. 7, No. 4, pp. 823-841, Dec. 2010.",
          cal: "(SCIe, 2010 IF=0.324) (DOI: 10.2298/CSIS081223028L) (Times Cited: 2)",
          path: "http://www.doiserbia.nb.rs/Article.aspx?id=1820-02141000028L#.Yvn-6XZByUk",
        },

        {
          num: "(J10).",
          name: "Chuin-Mu Wang, Tsung-Hung Lin, Ruey-Maw Chen, and Sheng-Chih Yang (2010),",
          ca: "“Application of Grey System Theory in MRI Classification”",
          num2: ", Biomedical Engineering: Applications, Basis and Communications (BME) (ISSN: 1016-2372), Vol. 22, No. 2, pp. 111-118, April 2010.",
          cal: "(SCIe, EI) (DOI: 10.4015/S1016237210001827) (Times cited:1)",
          path: "http://www.worldscinet.com/bme/22/2202/S1016237210001827.html",
        },

        {
          num: "(J09).",
          name: "Cheng-Chi Lee, Tsung-Hung Lin, and Chwei-Shyong Tsai (2009),",
          ca: "A New Authenticated Group Key Agreement in a Mobile Environment“",
          num2: ", Annals of Telecommunications, Vol. 64, Nos. 11-12, pp. 735-744, Nov. 2009.",
          cal: "(SCI, SCIe, EI, 2008 IF=0.333) (DOI:10.1007/s12243-009-0096-z) (NSC97-2218-E-468-010) (Times Cited: 36)",
          path: "http://www.springerlink.com/content/j60r66688l751873/",
        },

        {
          num: "(J08).",
          name: "Chi-Yuan Lin, Tsung-Hung Lin, Sheng-Chih Yang, Yin-Chen Lin, and Bing-Yi Lee (2009),",
          ca: "“Tumor Feature Reserved Compression Systems for Mammograms“",
          num2: ", Journal of Image Processing and Communication (JIPC), Vol. 1, No. 1, pp. 01-10, Dec. 2009.",
          cal: "(NSC96-2221-E-167-021)",
          path: "http://jipc.ypu.edu.tw/",
        },

        {
          num: "(J07).",
          name: "Yuh-Shyan Chen and Tsung-Hung Lin* (2007),",
          ca: "“A Time-Slot Leasing-Based QoS Routing Protocol over Bluetooth WPANS“",
          num2: ",International Journal of Ad Hoc and Ubiquitous Computing (IJAHUC), Vol. 2, Nos. 1/2, pp. 92-108, 2007.",
          cal: "(SCIe, EI, 2007 IF=0.66) (DOI: 10.1504/IJAHUC.2007.011607) (Times Cited: 5)",
          path: "http://www.inderscience.com/search/index.php?action=record&amp;rec_id=11607",
        },

        {
          num: "(J06).",
          name: "Yuh-Shyan Chen, Tsung-Hung Lin, and Yun-Wei Lin (2007),",
          ca: "“A Hexagonal-Tree TDMA-Based QoS Multicasting for Wireless Mobile Ad-Hoc Networks“",
          num2: ", Telecommunication Systems, Vol. 35, No. 1-2, pp. 1-20, June 2007.",
          cal: "(SCI, SCIe, EI, 2005 IF=0.409, ranking=57.63%) (DOI: 10.1007/s11235-007-9037-1) (NSC92-2213-E-194-022, NSC94-2213-E-194-030) (Times Cited: 13)",
          path: "http://www.springerlink.com/content/08224344g6738614/?p=218f70fc28ae46f1b09802da4a171112&pi=0",
        },

        {
          num: "(J05).",
          name: "Yuh-Shyan Chen, Tsung-Hung Lin, and Shih-Min Lin (2007),",
          ca: "“RAA: A Ring-Based Address Autoconfiguration Protocol in Mobile Ad Hoc Networks“",
          num2: ", Wireless Personal Communications, Vol. 43, No. 2, pp. 549-571, Oct. 2007.",
          cal: "(SCI, SCIe, EI, 2005 IF=0.311, ranking=69.49%) (DOI: 10.1007/s11277-007-9249-4) (NSC94-2213-E-194-030, NSC95-2221-E-305-008) (Times Cited: 4)",
          path: "http://www.springerlink.com/content/rx77344t96x2n281/",
        },

        {
          num: "(J04).",
          name: "Tsung-Hung Lin*, Yuh-Shyan Chen, and Shin-Ling Lee (2005),",
          ca: "“PCAR: A Power-Aware Chessboard-Based Adaptive Routing Protocol for Wireless Sensor Networks“",
          num2: ", Journal of Internet Technology, Vol. 6, No. 1, pp. 77-87, April 2005.",
          cal: "(SCIe, EI) (DOI:10.1109/CASSET.2004.1322940) (NSC92-2213-E-194-022)",
          path: "https://ieeexplore.ieee.org/document/1322940?arnumber=1322940",
        },

        {
          num: "(J03).",
          name: "Yuh-Shyan Chen, Tsung-Hung Lin, and Jung-Yu Chien (2005),",
          ca: "“A Fast Code Assignment Strategy for W-CDMA Rotated-OVSF Tree with Code-Locality Capability“",
          num2: ", Telecommunication Systems, Vol. 29, No. 3, pp. 199-218 July 2005.",
          cal: "(SCI, SCIe, EI, 2004 IF=0.346, ranking=57.89%) (DOI: 10.1007/s11235-005-1691-6) (NSC91-2213-E-194-041 and NSC91-2213-E-194-042)(Times Cited: 1)",
          path: "http://www.springerlink.com/content/qj6v22j545uum387/",
        },

        {
          num: "(J02).",
          name: "Yuh-Shyan Chen, Chih-Yung Chang, Tsung-Hung Lin, and Chun-Bo Kuo (2005),",
          ca: "“A Generalized Fault-Tolerant Sorting Algorithm on Product Networks“",
          num2: ", Journal of Systems Architecture, Vol. 51, pp. 185-205, 2005.",
          cal: "(SCI, SCIe, EI, 2004 IF=0.242, ranking=88.64%) (DOI:10.1016/j.sysarc.2004.11.005) (NSC89-2213-E-216-010)",
          path: "https://linkinghub.elsevier.com/retrieve/pii/S1383762104001195",
        },

        {
          num: "(J01).",
          name: "Yuh-Shyan Chen, Tsung-Hung Lin, Yau-Wen Nian, and Jang-Ping Sheu (2003),",
          ca: "“An Energy-Efficient Diagonal-Based Directed Diffusion for Wireless Sensor Networks“",
          num2: ", Journal of Computers, Vol. 15, No. 1, pp. 11-25, March 2003.",
          cal: "(91A-H-FA07-1-4)",
          path: "",
        },
      ],
      book: [
        {
          num: "(B02).",
          name: "超端領先 科技未來：智慧系統概論 深石數位",
          ca: "ISBN",
          num2: "978-986-500-136-0",
          cal: "(2018.03.26)",
          path: "https://www.books.com.tw/products/0010784574",
        },

        {
          num: "(B01).",
          name: "工業4.0翻轉技職 國立勤益科技大學",
          ca: "ISBN",
          num2: "978-986-048-953-8",
          cal: " (2016.06)",
          path: "https://www.govbooks.com.tw/books/110959",
        },
      ],
      patents: [
        {
          num: "(P02).",
          name: "具有移動靶功能的物聯網開發板教具",
          ca: "國立勤益科技大學",
          num2: "中華民國專利證書發明第I669693號",
          cal: "(2019.08.21~2037.09.11)",
          path: publication_path[++Indexbook],
        },

        {
          num: "(P01).",
          name: "物聯網開發板控制車",
          ca: "國立勤益科技大學",
          num2: "中華民國專利 新型第M559492號",
          cal: "(2018.05.01~2027.09.11)",
          path: publication_path[++Indexbook],
        },
      ],
      International_conference: [
      {
          num: "(IC42).",
          name: "Tsung-Hung Lin and Hung-Liang Huang (2023),",
          ca: "“Cybersecurity of Smart Grid for Health Facilities with Wi-SUN Architecture.“",
          num2: ", in Proceedings of the 7th International Conference on Medical and Health Informatics (ICMHI 2023), Kyoto, Japan, 12-14 May 2023.",
          cal: "(ACM ICPS Proceeding ISBN: 979-8-4007-0071-2)(Best Presentations Award)",
          path: "",
          path2: "http://www.icmhi.org/ICMHI2023.html",
        },
        {
          num: "(IC41).",
          name: "Tian-Fu Lee, Yu-Hsiang Wang, Wei-Jie Huang, Chun-wei Hsu, and Tsung-Hung Lin (2021),",
          ca: "“A Secure and Efficient Access Control Scheme Based on PUF for Health Information Systems.“",
          num2: ", in Proceedings of the 5th International Conference on Medical and Health Informatics (ICMHI2021), Kyoto, Japan, 14-16 May 2021.",
          cal: "(ACM ICPS Proceeding ISBN: 978-1-4503-8984-6)(https://doi.org/10.1145)(Ei Compendex, Scopes and Thomson Reuters Conference Proceedings Citation Index (ISI Web of Science))",
          path: "",
          path2: "http://www.icmhi.org/ICMHI2020.html",
        },

        {
          num: "(IC40).",
          name: "Tsung-Hung Lin*, Kuan-Han Chen, Jun-Ping Cao, and Yu-Jie (Jessica) Kuo (2021),",
          ca: "“A Gesture Recognition Instant Response System for Mobile Devices“",
          num2: ", in Proceedings of the 2021 Conference on Applications of Innovation & Invention (AII 2021), Taichung, Taiwan, 26 March 2021.",
          cal: "(ISBN:978-986-503-577-8 ) (Best Conference Paper Award)",
          path: "",
          path2: "",
        },

        {
          num: "(IC39).",
          name: "Ming-Te Chen, Chia-Chu Chen, and Tsung-Hung Lin* (2020),",
          ca: "“A Cryptanalysis of Trustworthy Electronicvoting using Adjusted Blockchain Technology.“",
          num2: ", in Proceedings of the 4th International Conference on Medical and Health Informatics (ICMHI2020), Kamakura City, Japan, 14-16 August 2020.",
          cal: "(ACM ICPS Proceeding ISBN: 978-1-4503-7776-8)(https://doi.org/10.1145/3418094.3418143)(Ei Compendex, Scopes and Thomson Reuters Conference Proceedings Citation Index (ISI Web of Science))",
          path: "",
          path2: "http://www.icmhi.org/ICMHI2020.html",
        },

        {
          num: "(IC38).",
          name: "Tsung-Hung Lin*, Dominic Lau Yeoh Foo, and Yu-Jie Jessica Kuo (2019),",
          ca: "“A Design of Python Communication Module between Fog and IoT devices.“",
          num2: ", in Proceedings of the 2019 Conference on Applications of Innovation & Invention (AII 2019), Taichung, Taiwan, Nov. 15, 2019.",
          cal: "(ISBN:978-986-503-271-5) (Best Conference Paper Award)",
          path: "",
          path2: "",
        },

        {
          num: "(IC37).",
          name: "Chwei-Shyong Tsai, Qi-Xian Huang, Tsung-Hung Lin, and Tian-Fu Lee (2019),",
          ca: "“Computation-Efficient Three-Party Encrypted Key Exchange for Telecare Medicine Information Systems.“",
          num2: ", in The 2019 3rd International Conference on Medical and Health Informatics (ICMHI 2019), Xiamen, China, May 17~19, 2019.",
          cal: "(ACM ICPS Proceeding ISBN: 978-1-4503-7199-5) (Ei Compendex, Scopes and Thomson Reuters Conference Proceedings Citation Index (ISI Web of Science))",
          path: "",
          path2: "",
        },

        {
          num: "(IC36).",
          name: "Tsung-Hung Lin, Sandile Malinga*, Hui-Kai Chen, Jia-Hao Lin, and Yu-Jie Kuo (2018),",
          ca: "“An Identification System Using Deep Learning for Face Recognition.“",
          num2: ", in Proceedings of the 2018 Conference on Applications of Innovation & Invention (AII 2018), Taichung, Taiwan, Nov. 23, 2018.",
          cal: "(ISBN:978-986-463-971-7) (Best Conference Paper Award)",
          path: "",
          path2: "",
        },

        {
          num: "(IC35).",
          name: "Cheng-Jian Lin, Hsueh-Yi Lin, Cheng-Yi Yu, and Tsung-Hung Lin (2018),",
          ca: "“A Hybird of Fuzzy Theory and Quadratic Function for Estimating and Refining Transmission.“",
          num2: ", in The 4th IEEE International Conference on Applied System Innovation 2018 (IEEE ICASI 2018), Chiba, Tokyo, Japan, April 13~17, 2018.",
          cal: "",
          path: "",
          path2: "",
        },

        {
          num: "(IC34).",
          name: "Yun-Shuai Yu, Chih-Heng Ke, Tsung-Hung Lin, and Yeong-Sheng Chen (2017),",
          ca: "“Research and Practice of Industrial Wireless Sensor Network Based on OpenWSN.“",
          num2: ", in The 2017 International Conference on Smart Science (ICSS2017), Huis Ten Bosch, Kyushy, Japan, April 06~10, 2017.",
          cal: "",
          path: "",
          path2: "",
        },

        {
          num: "(IC33).",
          name: "Wei-Jan Lin and Tsung-Hung Lin* (2017),",
          ca: "“A Research on Improving Vehicle Scheduling Efficiency by Using Machine Learning.“",
          num2: ", in The 2017 International Conference on Smart Science (ICSS2017),",
          cal: "Huis Ten Bosch, Kyushy, Japan, April 06~10, 2017.",
          path: "",
          path2: "",
        },

        {
          num: "(IC32).",
          name: "Jyun-Guo Wang, Shen-Chuan Tai, Chin-Ling Lee, Cheng-Jian Lin, and Tsung-Hung Lin (2016),",
          ca: "“Using a hybrid of fuzzy theory and neural network filter for image dehazing applications.“",
          num2: ", in The 2016 International Joint Conference on Neural Networks (IJCNN), (ISBN:978-1-5090-0619-9), Vancouver, Canada, pp.692-697, July, 2016.",
          cal: "(DOI:10.1109/IJCNN.2016.7727267)",
          path: "",
          path2: "",
        },

        {
          num: "(IC31).",
          name: "Shan-Chun Hung, Tsung-Hung Lin, Zeng-Bo Wang, and Tung-Lin Wu (2016),",
          ca: "“Round-Efficeient Group Authenicationed Key Agreement Based on Extended Chaotic Maps.“",
          num2: ", in The IEEE 2016 International Conference on Applied System Innovation (ICASI 2016), Okinawa, Japan, no:0552, May 28~June 1, 2016.",
          cal: "(Best Conference Paper Award)",
          path: "",
          path2: "",
        },

        {
          num: "(IC30).",
          name: "Chi-Yuan Lin, Yu-Hsien Chu, Tsung-Hung Lin, and Jyun-Jie Wang (2015),",
          ca: "“Iterative decoding for Convolutional Codes with Parallel Concatenated Form.“",
          num2: ", in Proceedings of the 10th Intelligent Living Technology Conference (ILT2015) (ISBN: 978-957-21-9894-0), Taichung, Taiwan, pp.1034-1037, June 05, 2015.",
          cal: "(Honorable Mention Paper of ILT2015)",
          path: "",
          path2: "",
        },

        {
          num: "(IC29).",
          name: "Tsung-Hung Lin* and Chia-Hao Chang (2015),",
          ca: "“A user authentication and key agreement scheme for heterogeneous ad hoc wireless sensor networks.“",
          num2: ", in Proceedings of the 10th Intelligent Living Technology Conference (ILT2015) (ISBN: 978-957-21-9894-0), Taichung, Taiwan, pp.1046-1050, June 05, 2015.",
          cal: "(MOST 103-2221-E-167-028)",
          path: "",
          path2: "",
        },

        {
          num: "(IC28).",
          name: "Cheng-Yi Yu, Hsueh-Yi Lin, and Tsung-Hung Lin (2015),",
          ca: "“Image Contrast Enhancement Method Based on Adaptive Parameter of Fuzzy Theory.“",
          num2: ", in Proceedings of the 2015 International Conference on Applied System Innovation (ICASI 2015), Osaka, Japan, May 22~27, 2015.",
          cal: "(MOST 103-2221-E-167-028)",
          path: "",
          path2: "",
        },

        {
          num: "(IC27).",
          name: "Tsung-Hung Lin* and Chia-Hao Chang (2014),",
          ca: "“A secure authentication scheme base on chaotic maps using biometric smart cards“",
          num2: ", in Proceedings of the 13th International Conference on Information and Management Sciences (IMS2014), Zhangjiajie, China, August 3-8, 2014.",
          cal: "",
          path: "",
          path2: "",
        },

        {
          num: "(IC26).",
          name: "Tsung-Hung Lin, Wei-Yu Chen, and Ji-Han Jiang (2014),",
          ca: "“A Novel Document Tampering Forensic Scheme Using Image Heterogeneous Channel“",
          num2: ", in Proceedings of the 13th International Conference on Information and Management Sciences (IMS2014), Zhangjiajie, China, August 3-8, 2014.",
          cal: "",
          path: "",
          path2: "",
        },

        {
          num: "(IC25).",
          name: "Tian-Fu Lee, Chuan-Ming Liu, and Tsung-Hung Lin* (2013),",
          ca: "“A Efficient Chaotic Maps-Based Authenticated Key Agreements with Privacy Protection“",
          num2: ", inProceedings of the 2013 National Computer Symposium (NCS 2013), Taichung, Taiwan, Dec. 13-14, 2013.",
          cal: "",
          path: "",
          path2: "",
        },

        {
          num: "(IC24).",
          name: "Tsung-Hung Lin*, Derting Lee, and Chih-Nan Yu (2013),",
          ca: "“A research on .NET application program to access Excel format file:NPOI“",
          num2: ", in Proceedings of the eighth Intelligent Living Technology Conference (ILT2013) (ISBN: 978-957-21-8962-7), Taichung, Taiwan, pp. 370-372 , June. 07, 2013.",
          cal: "",
          path: "",
          path2: "",
        },

        {
          num: "(IC23).",
          name: "Tsung-Hung Lin* and Ting-Yu Lin (2012),",
          ca: "“A weakness of the biometric-based remote user authentication using smart cards“",
          num2: ", inProceedings of the 2nd Conference on Applications of Innovation and Invention, (AII2012)(ISBN: 978-957-21-8725-8), Taichung, Taiwan, pp.452-456, Nov. 23, 2012.",
          cal: "",
          path: "",
          path2: "",
        },

        {
          num: "(IC22).",
          name: "Chun-Jung Lee, Wei-Bin Lee, Chin-Sheng Liu, Kevin Ho, Chyi-Ren Dow, and Tsung-Hung Lin (2012),",
          ca: "“A Novel Friendly Image-Based CAPTCHA with Auto-Generation of Test Data“",
          num2: ", in Proceedings of the 7th International Conference on Information Warfare and Security (ICIW2012), Seattle, USA, March 22-23, 2012.",
          cal: "",
          path: "",
          path2: "",
        },

        {
          num: "(IC21).",
          name: "Tsung-Hung Lin*, Heng-Wei Wu, and Chi-Yuan Lin (2011),",
          ca: "“An Integrated RFID Entrance Guard Group-Oriented Secret Sharing Scheme“",
          num2: ", in Proceedings of the sixth Intelligent Living Technology Conference (ILT2011)(ISBN: 978-957-21-8031-0), Taichung, Taiwan, pp.324-330, June 3, 2011.",
          cal: "",
          path: "",
          path2: "",
        },

        {
          num: "(IC20).",
          name: "Chi-Yuan Lin, Tzu-Wei Yu, Tsung-Hung Lin, and Cheng-Yi Yu (2011),",
          ca: "“Two-Scale Image Contrast Enhancement based on Adaptive Power Function“",
          num2: ", in Proceedings of the sixth Intelligent Living Technology Conference (ILT2011)(ISBN: 978-957-21-8031-0), Taichung, Taiwan, pp.2240-2245, June 3, 2011.",
          cal: "",
          path: "",
          path2: "",
        },

        {
          num: "(IC19).",
          name: "Bor-Woei Lee, Hong-Hao Chen, Chih-Chiang Lee, and Tsung-Hung Lin* (2010),",
          ca: "“A New Matrix Decode Scheme for Error Diffusion on Visual Share Images“",
          num2: ", in Proceedings of the 2010 International Computer Symposium (ICS2010), Tainan, Taiwan, Dec. 16-18, 2010.",
          cal: "(EI)",
          path: "",
          path2: "",
        },

        {
          num: "(IC18).",
          name: "Ji-Han Jiang, Tsung-Hung Lin*, Kuang-Hui Chi, Tzong-Chen Wu, and Chun-Shen Wu (2010),",
          ca: "“Load-Aware Geographic Routing in Wireless Sensor Networks“",
          num2: ", in Proceedings of the Ninth International Conference on Information and Management Sciences(IMS2010), Urumchi, China, August 11-19, 2010.",
          cal: "",
          path: "",
          path2: "",
        },

        {
          num: "(IC17).",
          name: "Tsung-Hung Lin*, Ni-Shan Shiao, Hong-Hao Chen, and Chwei-Shyong Tsai (2010),",
          ca: "“A new non-expansion visual cryptography scheme with high quality of recovered image“",
          num2: ", in Proceedings of the IET International Conference on Frontier Computing – Theory, Technologies and Applications (IET FC2010)(ISBN: 978-1-84919-208-8), Taichung, Taiwan, August 4-6, 2010.",
          cal: "(EI)",
          path: "",
          path2: "",
        },

        {
          num: "(IC16).",
          name: "Tsung-Hung Lin* and Shen-Heng Huang (2010),",
          ca: "“An Efficient key agreement protocol for three parties without server public key“",
          num2: ", inProceedings of the Fifth Intelligent Living Technology Conference (ILT2010)(ISBN: 978-957-21-7647-4), Taichung, Taiwan, June 4, 2010.",
          cal: "",
          path: "",
          path2: "",
        },

        {
          num: "(IC15).",
          name: "Tsung-Hung Lin* and Hung-Wei Liu (2009),",
          ca: "“A new cross-layer ZigBee routing protocol using Discrete Distributed Topology-control Algorithm“",
          num2: ", in Proceedings of the 2009 Workshop on Consumer Electronics (WCE2009), Taichung, Taiwan, pp. 367-372, Nov. 06, 2009.",
          cal: "",
          path: "",
          path2: "",
        },

        {
          num: "(IC14).",
          name: "Tsung-Hung Lin* and Yin-Chen Lin (2009),",
          ca: "“Tumor Contour Detection and Compression Systems Using VQ-BTC for Mammograms“",
          num2: ", in Proceedings of the 2009 Workshop on Consumer Electronics (WCE2009)(ISBN: 978-957-21-7330-5), Taichung, Taiwan, pp. 468-474, Nov. 06, 2009.",
          cal: "",
          path: "",
          path2: "",
        },

        {
          num: "(IC13).",
          name: "Sheng-Chih Yang, Chi-Yuan Lin, Tsung-Hung Lin, Yin-Chen Lin, and Chieh-Ling Huang (2009),",
          ca: "“Breast MRI Contrast Enhancement for Particular Object Using Constrained Energy Minimization Method“",
          num2: ", in Proceedings of the 2009 International Conference on Digital Content (ICDC2009), Taiwan, 2009.",
          cal: "",
          path: "",
          path2: "",
        },

        {
          num: "(IC12).",
          name: "Chuin-Mu Wang, Tsung-Hung Lin, Ruey-Maw Chen, and Hui-Jun Wang (2009),",
          ca: "“Application of Grey System Theory in MRI Classification“",
          num2: ", in Proceedings of the 22th IPPR Conference on Computer Vision, Graphics, and Image Processing (CVGIP 2009),Nantou, Taiwan, Aug. 23-25, 2009.",
          cal: "",
          path: "",
          path2: "",
        },

        {
          num: "(IC11).",
          name: "Chi-Yuan Lin, Sheng-Chih Yang, Tsung-Hung Lin, Yin-Chen Lin, and Bing-Yi Lee (2008),",
          ca: "“An Integration Design of Tumor Contour Detection and Compression for Mammograms“",
          num2: ", in Proceedings of the International Conference on Digital Content (ICDC2008), pp. 119-125, Chungli, Taiwan, Dec. 26, 2008.",
          cal: "",
          path: "",
          path2: "",
        },

        {
          num: "(IC10).",
          name: "Ruey-Maw Chen, Shih-Tang Lo, Chung-Lun Wu, and Tsung-Hung Lin (2008),",
          ca: "“An Effective Ant Colony Optimization-Based Algorithm for Flow Shop Scheduling“",
          num2: ", in Proceedings of the 2008 IEEE Conference on Soft Computing in Industrial Applications (SMCia/08), Muroran, Japan, June 25-27, 2008.",
          cal: "",
          path: "",
          path2: "",
        },

        {
          num: "(IC09).",
          name: "Tsung-Hung Lin*, Thin-Lian Huang, Jiang-Nan Jow, and Chuin-Mu Wang (2008),",
          ca: "“Order Management with the Application of Mobile Wireless Communication“",
          num2: ", in Proceedings of the Third Intelligent Living Technology Conference (ILT2008)(ISBN:9789572158548), Taichung, Taiwan, June 6, 2008.",
          cal: "",
          path: "",
          path2: "",
        },

        {
          num: "(IC08).",
          name: "Chuin-Mu Wang, Chien-De Shao, Tsung-Hung Lin, and Sheng-Wei Wang (2008),",
          ca: "“A Design of Physical Fitness Measuring Apparatus“",
          num2: ", in Proceedings of the Third Intelligent Living Technology Conference (ILT2008)(ISBN:9789572158548), Taichung, Taiwan, June 6, 2008.",
          cal: "",
          path: "",
          path2: "",
        },

        {
          num: "(IC07).",
          name: "Yuh-Shyan Chen, Tsung-Hung Lin, and Po-Tsai Hsieh (2007),",
          ca: "“A Bow-Based QoS Routing Protocol for MIMO Ad Hoc Networks“",
          num2: ", inProceeding of the ACM International Wireless Communications and Mobile Computing Conference (IWCMC 2007), Turtle Bay Resort, Honolulu, Hawaii, August 12-16, 2007.",
          cal: "",
          path: "",
          path2: "",
        },

        {
          num: "(IC06).",
          name: "(IC06).",
          ca: "“On-demand Deflecting Routing for Optical Brust Switched Networks“",
          num2: ", in Proceeding of the 1st Cross-Strait Seminar on Engineering & Technology Education and Industry-Academy Integration (2007THE), Changzhou, Jiangsu, China, pp. 50-56, Dec. 7-8, 2007.",
          cal: "",
          path: "",
          path2: "",
        },

        {
          num: "(IC05).",
          name: "Shih-Yuan Huang, Jzau-Sheng Lin, shao-han Liu, and Tsung-Hung Lin (2007),",
          ca: "“Character Recognition Based on the CMAC with an Annealed Chaotic Learning“",
          num2: ", in Proceeding of the 1st Cross-Strait Seminar on Engineering & Technology Education and Industry-Academy Integration (2007THE), Changzhou, Jiangsu, China, pp. 32-37, Dec. 7-8, 2007.",
          cal: "",
          path: "",
          path2: "",
        },

        {
          num: "(IC04).",
          name: "Yuh-Shyan Chen and Tsung-Hung Lin* (2005),",
          ca: "“A QoS Routing Protocol using Cluster-Mesh-Tree for IEEE 802.15.4 Low-Rate WPANs“",
          num2: ", in Proceeding of the Workshop on Wireless, Ad Hoc and Sensor Networks (WASN 2005), Chung-Li, Taiwan, Aug. 1-2, 2005.",
          cal: "",
          path: "",
          path2: "",
        },

        {
          num: "(IC03).",
          name: "Yuh-Shyan Chen and Tsung-Hung Lin* (2005),",
          ca: "“A Centralized Time-Slot Leasing-Based QoS Routing Protocol over Bluetooth WPANS“",
          num2: ", in Proceeding of the IASTED Conference on Wireless Networks and Emerging Technologies (WNET 2005), Banff, Alberta, Canada, July 19-21, 2005.",
          cal: "",
          path: "",
          path2: "",
        },
        {
          num: "(IC02).",
          name: "Yuh-Shyan Chen and Tsung-Hung Lin (2005),",
          ca: "“A Time-Slot Leasing-Based QoS Routing Protocol over Bluetooth WPANS“",
          num2: ", inProceeding of the Workshop on Mobile Computing (MC2005), Chang Gung University, Taoyuan, Taiwan, pp. 342-351, March 31, 2005.",
          cal: "",
          path: "",
          path2: "",
        },

        {
          num: "(IC01).",
          name: "Tsung-Hung Lin*, Yuh-Shyan Chen, and Shinling Lee (2004),",
          ca: "“PCAR: A Power-Aware Chessboard-Based Adaptive Routing Protocol for Wireless Sensor Networks“",
          num2: ", in Proceeding of the IEEE CAS Symposium on Emerging Technologies, Frontiers of Mobile and Wireless Communication (MWC04), Shanghai, China, Vol. I, pp. 145-148, May 31- June 2, 2004.",
          cal: "",
          path: "",
          path2: "",
        },
      ],
      other_conference: [
        {
          num: "(LC75).",
          name: "林宗宏、郭宇婕、林承邑、張景淳(2026),",
          ca: "結合物件偵測與生成式影像修補之影像隱私保護方法",
          num2: ", 𝑡ℎ𝑒 20𝑡ℎ 𝐼𝑛𝑡𝑒𝑙𝑙𝑖𝑔𝑒𝑛𝑡 𝐿𝑖𝑣𝑖𝑛𝑔 𝑇𝑒𝑐ℎ𝑛𝑜𝑙𝑜𝑔𝑦 𝐶𝑜𝑛𝑓𝑒𝑟𝑒𝑛𝑐𝑒 (𝐼𝐿𝑇 2026), (ISBN:978-626-401-757-2), (佳作),",
          cal: " Taichung, Taiwan, pp.615-620, 5 June 2026.",
          path: "",
        },
		    {
          num: "(LC74).",
          name: "林宗宏、郭宇婕、楊承諭(2026),",
          ca: "基於 Wazuh 與 n8n 自動化網頁置換監測即時告警研究",
          num2: ", 𝑡ℎ𝑒 20𝑡ℎ 𝐼𝑛𝑡𝑒𝑙𝑙𝑖𝑔𝑒𝑛𝑡 𝐿𝑖𝑣𝑖𝑛𝑔 𝑇𝑒𝑐ℎ𝑛𝑜𝑙𝑜𝑔𝑦 𝐶𝑜𝑛𝑓𝑒𝑟𝑒𝑛𝑐𝑒 (𝐼𝐿𝑇 2026), (ISBN:978-626-401-757-2), (佳作),",
          cal: " Taichung, Taiwan, pp.605-609, 5 June 2026.",
          path: "",
        },
		    {
          num: "(LC73).",
          name: "林宗宏、郭宇婕、吳懿仁(2026),",
          ca: "伺服器安全組態資安稽核輔助代理研究",
          num2: ", 𝑡ℎ𝑒 20𝑡ℎ 𝐼𝑛𝑡𝑒𝑙𝑙𝑖𝑔𝑒𝑛𝑡 𝐿𝑖𝑣𝑖𝑛𝑔 𝑇𝑒𝑐ℎ𝑛𝑜𝑙𝑜𝑔𝑦 𝐶𝑜𝑛𝑓𝑒𝑟𝑒𝑛𝑐𝑒 (𝐼𝐿𝑇 2026), (ISBN:978-626-401-757-2), ",
          cal: " Taichung, Taiwan, pp.610-614, 5 June 2026.",
          path: "",
        },
		    {
          num: "(LC72).",
          name: "林宗宏、郭宇婕、賴韋翰(2025),",
          ca: "整合OPNsense與Wazuh之APT智慧監控研究",
          num2: ", in 𝑃𝑟𝑜𝑐. 𝑡ℎ𝑒 18𝑡ℎ 𝐼𝑛𝑓𝑜𝑟𝑚𝑎𝑡𝑖𝑜𝑛 𝐸𝑑𝑢𝑐𝑎𝑡𝑖𝑜𝑛 𝑎𝑛𝑑 𝑇𝑒𝑐ℎ𝑛𝑜𝑙𝑜𝑔𝑖𝑐𝑎𝑙 𝐴𝑝𝑝𝑙𝑖𝑐𝑎𝑡𝑖𝑜𝑛𝑠 𝐶𝑜𝑛𝑓𝑒𝑟𝑒𝑛𝑐𝑒 (𝐼𝐸𝑇𝐴𝐶 2025), (ISBN:978-626-970-986-1), (佳作),",
          cal: " Taichung, Taiwan, pp.168-171, 19 November 2025.",
          path: "",
        },
        {
          num: "(LC71).",
          name: "林宗宏、郭宇婕、蔡元豪(2025),",
          ca: "技術脆弱性風險評估機制之強化研究",
          num2: ", in 𝑃𝑟𝑜𝑐. 𝑡ℎ𝑒 18𝑡ℎ 𝐼𝑛𝑓𝑜𝑟𝑚𝑎𝑡𝑖𝑜𝑛 𝐸𝑑𝑢𝑐𝑎𝑡𝑖𝑜𝑛 𝑎𝑛𝑑 𝑇𝑒𝑐ℎ𝑛𝑜𝑙𝑜𝑔𝑖𝑐𝑎𝑙 𝐴𝑝𝑝𝑙𝑖𝑐𝑎𝑡𝑖𝑜𝑛𝑠 𝐶𝑜𝑛𝑓𝑒𝑟𝑒𝑛𝑐𝑒 (𝐼𝐸𝑇𝐴𝐶 2025), (ISBN:978-626-970-986-1), ",
          cal: " Taichung, Taiwan, pp.183-188, 19 November 2025.",
          path: "",
        },
        {
          num: "(LC70).",
          name: "林宗宏、郭宇婕、徐翌瑄(2025),",
          ca: "一種用於CPS安全軟體開發生命週期之框架",
          num2: ", in 𝑃𝑟𝑜𝑐. 𝑡ℎ𝑒 18𝑡ℎ 𝐼𝑛𝑓𝑜𝑟𝑚𝑎𝑡𝑖𝑜𝑛 𝐸𝑑𝑢𝑐𝑎𝑡𝑖𝑜𝑛 𝑎𝑛𝑑 𝑇𝑒𝑐ℎ𝑛𝑜𝑙𝑜𝑔𝑖𝑐𝑎𝑙 𝐴𝑝𝑝𝑙𝑖𝑐𝑎𝑡𝑖𝑜𝑛𝑠 𝐶𝑜𝑛𝑓𝑒𝑟𝑒𝑛𝑐𝑒 (𝐼𝐸𝑇𝐴𝐶 2025), (ISBN:978-626-970-986-1), ",
          cal: " Taichung, Taiwan, pp.163-167, 19 November 2025.",
          path: "",
        },
        {
          num: "(LC69).",
          name: "林宗宏、郭宇婕、張義堃(2025),",
          ca: "整合ERP智慧工業派車系統",
          num2: ", in 𝑃𝑟𝑜𝑐. 𝑡ℎ𝑒 18𝑡ℎ 𝐼𝑛𝑓𝑜𝑟𝑚𝑎𝑡𝑖𝑜𝑛 𝐸𝑑𝑢𝑐𝑎𝑡𝑖𝑜𝑛 𝑎𝑛𝑑 𝑇𝑒𝑐ℎ𝑛𝑜𝑙𝑜𝑔𝑖𝑐𝑎𝑙 𝐴𝑝𝑝𝑙𝑖𝑐𝑎𝑡𝑖𝑜𝑛𝑠 𝐶𝑜𝑛𝑓𝑒𝑟𝑒𝑛𝑐𝑒 (𝐼𝐸𝑇𝐴𝐶 2025), (ISBN:978-626-970-986-1),(佳作), ",
          cal: " Taichung, Taiwan, pp.159-162, 19 November 2025.",
          path: "",
        },
        {
          num: "(LC68).",
          name: "林宗宏、林承邑(2025),",
          ca: "以GANs生成偽造人臉資料用於CNN真偽辨識效能之研究",
          num2: ", International Conference on Innovation and Design (ICID 2025) , (ISBN:978-626-99738-1-1), ",
          cal: "New Taipei City, Taiwan, pp.271-280, 31 October 2025.",
          path: "",
        },
        {
          num: "(LC67).",
          name: "林宗宏、楊朋展(2025),",
          ca: "結合欺敵策略與傳輸層安全性協定特徵比對之自動化購票行為偵測架構",
          num2: ", International Conference on Innovation and Design (ICID 2025) , (ISBN:978-626-99738-1-1), ",
          cal: "New Taipei City, Taiwan, pp.266-273, 31 October 2025.",
          path: "",
        },
        {
          num: "(LC66).",
          name: "黃仁紘、林宗宏*、黃建中、宋隆裕、潘秉毅、郭宇婕 (2024),",
          ca: "儲能系統案場導入IEC 62443探究",
          num2: ", 第21屆台灣電力電子研討會暨第45屆中華民國電力工程研討會, ",
          cal: "台南成大, Taiwan, pp.1-6, 22-23 November 2024.",
          path: "",
        },
        {
          num: "(LC65).",
          name: "林宗宏、何祐緯(2024),",
          ca: "工業物聯網資安異常監控中心建置",
          num2: ", in Proceedings of the 17th Information Education and Technological Applications Conference, (IETAC 2024) (ISBN:978-626-992-640-4), (佳作), ",
          cal: "Taichung, Taiwan, pp.106-110, 22 November 2024.",
          path: "",
        },
        {
          num: "(LC64).",
          name: "林宗宏、蔡兆哲(2024),",
          ca: "容器管理平台之基於角色的訪問控制（RBAC）權限安全研究",
          num2: ", in Proceedings of the 17th Information Education and Technological Applications Conference (IETAC 2024) (ISBN:978-626-992-640-4),",
          cal: "Taichung, Taiwan, pp.117-120, 22 November 2024.",
          path: "",
        },
        {
          num: "(LC63).",
          name: "林宗宏、何祐緯(2024),",
          ca: " 農業物聯網場域流量建模及資安戰情中心建置",
          num2: ", in Proceedings of the 14th national conference on web intelligence and applications conference, (NCWIA2024),",
          cal: "Yunlin, Taiwan, 22 July 2024.",
          path: "",
        },
        {
          num: "(LC62).",
          name: "林宗宏、温秉勳(2023),",
          ca: "一種網路流量監控可視化工控場域應用系統",
          num2: ", in Proceedings of the 17th Conference Intelligent Living Technology Conference, (ILT2023) (ISBN:978-626-328-448-7),",
          cal: "Taichung, Taiwan, 2 June 2023.",
          path: "",
        },
        {
          num: "(LC61).",
          name: "林宗宏、蔡兆哲(2023),",
          ca: "容器管理平台之基於角色的訪問控制權限安全研究",
          num2: ", in Proceedings of the 33th Conference Cryptology and Information Security Conference, (CISC2023) ,",
          cal: "Chiayi, Taiwan, 2 June 2023.",
          path: "",
        },
        {
          num: "(LC60).",
          name: "林宗宏、藍詠弘、陳政廷(2022),",
          ca: "一種非同質化代幣技術應用於會員社群平台",
          num2: ", in Proceedings of the 16th Conference Intelligent Living Technology Conference, (ILT2022) (ISBN:978-626-328-221-6),",
          cal: "Taichung, Taiwan, 2 June 2022.",
          path: "",
        },
        {
          num: "(LC59).",
          name: "林宗宏、何婉苓(2022),",
          ca: "一種基於 HTTP 通訊協定防止 CC 攻擊的方法",
          num2: ", in Proceedings of the 2022 Conference on Applications of Innovation & Invention, (AII2022) (ISBN:978-626-328-086-1),",
          cal: "Taichung, Taiwan, 8 April 2022.(BEST PAPER AWARD)",
          path: "",
        },
        {
          num: "(LC58).",
          name: "林宗宏、藍詠弘(2022),",
          ca: "一種非同質化代幣應用於房屋租賃契約平台",
          num2: ", in Proceedings of the 2022 Conference on Applications of Innovation & Invention, (AII2022) (ISBN:978-626-328-086-1),",
          cal: "Taichung, Taiwan, 8 April 2022.",
          path: "",
        },
        {
          num: "(LC57).",
          name: "林宗宏、胡修瑞(2022),",
          ca: "一種使用輕量化分散儲存保護資料機制以智慧農業為例",
          num2: ", in Proceedings of the 2022 Conference on Applications of Innovation & Invention, (AII2022) (ISBN:978-626-328-086-1),",
          cal: "Taichung, Taiwan, 8 April 2022.",
          path: "",
        },
        {
          num: "(LC56).",
          name: "林宗宏、黃士豪(2022),",
          ca: "一種應用於工業物聯網遠距離身分認證系統",
          num2: ", in Proceedings of the 2022 Conference on Applications of Innovation & Invention, (AII2022) (ISBN:978-626-328-086-1),",
          cal: "Taichung, Taiwan, 8 April 2022.",
          path: "",
        },
        {
          num: "(LC55).",
          name: "林宗宏、陳暉凱(2022),",
          ca: "一種基於輕量型網頁應用程式防火牆防護研究",
          num2: ", in Proceedings of the 2022 Conference on Applications of Innovation & Invention, (AII2022) (ISBN:978-626-328-086-1),",
          cal: "Taichung, Taiwan, 8 April 2022.",
          path: "",
        },
        {
          num: "(LC54).",
          name: "林宗宏、吳吉修(2022),",
          ca: "一種容器攻擊行為分析與防禦研究",
          num2: ", in Proceedings of the 2022 Conference on Applications of Innovation & Invention, (AII2022) (ISBN:978-626-328-086-1),",
          cal: "Taichung, Taiwan, 8 April 2022.",
          path: "",
        },
        {
          num: "(LC53).",
          name: "林宗宏、王昱傑(2021),",
          ca: "“一種基於浮水印技術於圖像用途授權驗證方法“",
          num2: ", in 2021 第十九屆離島資訊技術與應用研討會 (ITAOI2021) (ISBN:978-986—),",
          cal: "Kinmen, Taiwan, 28-29 May 2021.",
          path: "",
        },

        {
          num: "(LC52).",
          name: "林宗宏、黃泓喨、黃士豪、胡修瑞(2021),",
          ca: "“一種資訊視覺化智慧農業物聯網應用系統“",
          num2: ", in 2021 第十九屆離島資訊技術與應用研討會 (ITAOI2021) (ISBN:978-986—),",
          cal: "Kinmen, Taiwan, 28-29 May 2021.",
          path: "",
        },

        {
          num: "(LC51).",
          name: "林宗宏、曹俊屏、陳冠翰、藍詠弘(2021),",
          ca: "“一種低延遲的非接觸式人機互動方法“",
          num2: ", in 2021 第十九屆離島資訊技術與應用研討會 (ITAOI2021) (ISBN:978-986—),",
          cal: "Kinmen, Taiwan, 28-29 May 2021.",
          path: "",
        },

        {
          num: "(LC50).",
          name: "林宗宏、藍詠弘、王昱傑(2021),",
          ca: "“一種基於電腦視覺特徵檢測之人臉圖像去識別化技術“",
          num2: ", in Proceedings of the 2021 Conference on Applications of Innovation & Invention, (AII2021) (ISBN:978-986-503-577-8),",
          cal: "Taichung, Taiwan, 26 March 2021.",
          path: "",
        },

        {
          num: "(LC49).",
          name: "林宗宏、黃士豪、洪琮閔(2021),",
          ca: "“一種連接機器手臂之螺絲分類影像辨識互動系統“",
          num2: ", in Proceedings of the 2021 Conference on Applications of Innovation & Invention, (AII2021) (ISBN:978-986-503-577-8),",
          cal: "Taichung, Taiwan, 26 March 2021.",
          path: "",
        },

        {
          num: "(LC48).",
          name: "林宗宏、胡修瑞、賴信儒(2021),",
          ca: "“一種資料完整性保護機制以智慧農業環境為例“",
          num2: ", in Proceedings of the 2021 Conference on Applications of Innovation & Invention, (AII2021) (ISBN:978-986-503-577-8),",
          cal: "Taichung, Taiwan, 26 March 2021.",
          path: "",
        },

        {
          num: "(LC47).",
          name: "林宗宏、陳漢恩、黃泓喨、劉楊富(2019),",
          ca: "“一種基於超音波感測實現IoT智慧行人號誌警示系統“",
          num2: ", in Proceedings of the 2019 Conference on Applications of Innovation & Invention, (AII2019) (ISBN:978-986-503-271-5),",
          cal: "Taichung, Taiwan, Nov. 15, 2019.",
          path: "",
        },

        {
          num: "(LC46).",
          name: "林宗宏、張晉銘、陳漢恩(2019),",
          ca: "“一種以運動目的為導向之快速媒合系統“",
          num2: ", in Proceedings of the 2019 Conference on Applications of Innovation & Invention, (AII2019) (ISBN:978-986-503-271-5),",
          cal: "Taichung, Taiwan, pp.-, Nov. 15, 2019.",
          path: "",
        },

        {
          num: "(LC45).",
          name: "林宗宏、陳冠翰(2019),",
          ca: "“一種改良式低功耗廣域網路水產養殖監控系統“",
          num2: ", in Proceedings of the 2019 Conference on Applications of Innovation & Invention, (AII2019) (ISBN:978-986-503-271-5),",
          cal: "Taichung, Taiwan, Nov. 15, 2019.",
          path: "",
        },

        {
          num: "(LC44).",
          name: "林宗宏、謝宇彥、黃瀚柏(2019),",
          ca: "“一種改良式快速無線區域網路三點定位監測策略“",
          num2: ", in Proceedings of the 2019 Conference on Applications of Innovation & Invention, (AII2019) (ISBN:978-986-4503-271-5),",
          cal: "Taichung, Taiwan, Nov. 15, 2019.",
          path: "",
        },

        {
          num: "(LC43).",
          name: "林昶睿、林宗宏(2018),",
          ca: "“一種整合新資訊科技人工智慧生活管家“",
          num2: ", in Proceedings of the 2018 The 12-th Cross-Strait Technology, Humanity Education and Academy-Industry Cooperation Conference, (ISBN:978-986-463-994-6),",
          cal: "Taichung, Taiwan, Nov. 30, 2018.",
          path: "",
        },

        {
          num: "(LC42).",
          name: "林宗宏、謝宇彥、周凱哲 (2018),",
          ca: "“一種用於復健醫療的虛擬實境音樂遊戲“",
          num2: ", in Proceedings of the 2018 Conference on Applications of Innovation & Invention, (AII2018) (ISBN:978-986-463-971-7),",
          cal: "Taichung, Taiwan, Nov. 23, 2018.",
          path: "",
        },

        {
          num: "(LC41).",
          name: "林宗宏、陳漢恩 (2018),",
          ca: "“一種基於超音波防撞功能之四軸飛行器設計“",
          num2: ", in Proceedings of the 2018 Conference on Applications of Innovation & Invention, (AII2018) (ISBN:978-986-463-971-7),",
          cal: "Taichung, Taiwan, Nov. 23, 2018.",
          path: "",
        },

        {
          num: "(LC40).",
          name: "林昌儒、林家豪、林宗宏(2018),",
          ca: "“一種穿戴式裝置的資訊安全探討“",
          num2: ", in Proceedings of the 2018 Conference on Applications of Innovation & Invention, (AII2018) (ISBN:978-986-463-971-7),",
          cal: "Taichung, Taiwan, Nov. 23, 2018.",
          path: "",
        },

        {
          num: "(LC39).",
          name: "林宗宏、陳麒文 (2017),",
          ca: "“一種網路攻擊行為的分析與阻斷研究“",
          num2: ", in Proceedings of the 2017 Conference on Applications of Innovation & Invention, (AII2017) (ISBN:978-986-463-690-7),",
          cal: "Taichung, Taiwan, pp.259-262, Nov. 17, 2017. (Best Paper Award. 智慧安全應用創新與設計領域最佳論文)",
          path: "",
        },

        {
          num: "(LC38).",
          name: "林宗宏、林維展 (2017),",
          ca: "“一種使用物聯網技術進行大範圍生產履歷高效資料採擷方法“",
          num2: ", in Proceedings of the 2017 Conference on Applications of Innovation & Invention, (AII2017) (ISBN:978-986-463-690-7),",
          cal: "Taichung, Taiwan, pp.255-258, Nov. 17, 2017.",
          path: "",
        },

        {
          num: "(LC37).",
          name: "林宗宏、林昌儒 (2017),",
          ca: "“一種基於物聯網環境之智慧坦克大決戰“",
          num2: ", in Proceedings of the 2017 Conference on Applications of Innovation & Invention, (AII2017) (ISBN:978-986-463-690-7),",
          cal: "Taichung, Taiwan, pp.263-265, Nov. 17, 2017.",
          path: "",
        },

        {
          num: "(LC36).",
          name: "林宗宏、蕭瑞余 (2017),",
          ca: "“一種應用於公共運輸之區塊鏈機制探討“",
          num2: ", in Proceedings of the 2017 Conference on Applications of Innovation & Invention, (AII2017) (ISBN:978-986-463-690-7),",
          cal: "Taichung, Taiwan, pp.266-267, Nov. 17, 2017.",
          path: "",
        },

        {
          num: "(LC35).",
          name: "林宗宏、林家豪 (2017),",
          ca: "“一種物聯網開發環境的安全性探討-以Webduino為例“",
          num2: ", in Proceedings of the 2017 Conference on Applications of Innovation & Invention, (AII2017) (ISBN:978-986-463-690-7),",
          cal: "Taichung, Taiwan, pp.268-270, Nov. 17, 2017.",
          path: "",
        },

        {
          num: "(LC34).",
          name: "林宗宏、郭冠宏 (2017),",
          ca: "“一個應用於行動網路漫遊服務匿名身分認證協議“",
          num2: ", in Proceedings of the 2017 Conference on Applications of Innovation & Invention, (AII2017) (ISBN:978-986-463-690-7),",
          cal: "Taichung, Taiwan, pp.271-274, Nov. 17, 2017.",
          path: "",
        },

        {
          num: "(LC33).",
          name: "林宗宏、郭冠宏、楊于萱 (2016),",
          ca: "“一個新穎的影像辨識軟體密碼鎖“",
          num2: ", in Proceedings of the 2016 Conference on Applications of Innovation & Invention, (AII2016) (ISBN:978-986-463-392-0),",
          cal: "Taichung, Taiwan, pp.92-96, Nov. 09-10, 2016. (Best Paper Award. 多媒體安全應用創新與設計領域最佳論文)(MOST 104-2221-E-167-007)",
          path: "",
        },

        {
          num: "(LC32).",
          name: "柯志亨、游允帥、陳永昇、林宗宏 (2016),",
          ca: "“在有線與無線之軟體定義網路下運用多路徑傳輸提升影像傳輸品質之研究“",
          num2: ", in Proceedings of the 2016 Conference on Applications of Innovation & Invention, (AII2016) (ISBN:978-986-463-392-0),",
          cal: "Taichung, Taiwan, pp.109-113, Nov. 09-10, 2016.",
          path: "",
        },

        {
          num: "(LC31).",
          name: "林宗宏、王曾柏、方宇嘉 (2016),",
          ca: "“一種基於手繪圖形登入認證研究“",
          num2: ", in Proceedings of the 2016 Conference on Applications of Innovation & Invention, (AII2016) (ISBN:978-986-463-392-0),",
          cal: "Taichung, Taiwan, pp.97-102, Nov. 09-10, 2016.",
          path: "",
        },

        {
          num: "(LC30).",
          name: "林宗宏、施諭廷 (2015),",
          ca: "“一種使用進階PPVO適合平滑影像的可逆式資訊隱藏技術“",
          num2: ", in Proceedings of the 2015 Conference on Applications of Innovation & Invention, (AII2015) (ISBN:978-986-463-062-2),",
          cal: "Taichung, Taiwan, pp.301-305, Nov. 11, 2015. (Best Paper Award. 多媒體安全創新與設計領域最佳論文)(MOST 104-2221-E-167-007)",
          path: "",
        },

        {
          num: "(LC29).",
          name: "林宗宏、王曾柏 (2015),",
          ca: "“一種使用直方圖提升嵌入秘密訊息藏量的探討“",
          num2: ", in Proceedings of the 2015 Conference on Applications of Innovation & Invention, (AII2015) (ISBN:978-986-463-062-2),",
          cal: "Taichung, Taiwan, pp.306-309, Nov. 11, 2015. (MOST 104-2221-E-167-007)",
          path: "",
        },

        {
          num: "(LC28).",
          name: "林宗宏、張家豪 (2015),",
          ca: "“物聯網安全認證架構整合分析與設計“",
          num2: ", in Proceedings of the 2015 Conference on Applications of Innovation & Invention, (AII2015) (ISBN:978-986-463-062-2),",
          cal: "Taichung, Taiwan, pp.284-287, Nov. 11, 2015. (MOST 104-2221-E-167-007)",
          path: "",
        },

        {
          num: "(LC27).",
          name: "林宗宏、張家豪 (2015),",
          ca: "“一種基於無骨架構利用Leap Motion 之手部密碼辨識機制“",
          num2: ", in Proceedings of the 2015 Conference on Applications of Innovation & Invention, (AII2015) (ISBN:978-986-463-062-2),",
          cal: "Taichung, Taiwan, pp.288-292, Nov. 11, 2015. (MOST 104-2221-E-167-007)",
          path: "",
        },

        {
          num: "(LC26).",
          name: "林宗宏、施諭廷、吳東霖 (2015),",
          ca: "“非接觸式手指軌跡技術於圖形密碼之探討“",
          num2: ", in Proceedings of the 2015 Conference on Applications of Innovation & Invention, (AII2015) (ISBN:978-986-463-062-2),",
          cal: "Taichung, Taiwan, pp.293-296, Nov. 11, 2015.(MOST 104-2221-E-167-007)",
          path: "",
        },

        {
          num: "(LC25).",
          name: "林宗宏、王曾柏、吳東霖 (2015),",
          ca: "“一種使用猜拳遊戲進行密碼設計之研究“",
          num2: ", in Proceedings of the 2015 Conference on Applications of Innovation & Invention, (AII2015) (ISBN:978-986-463-062-2),",
          cal: "Taichung, Taiwan, pp.297-300, Nov. 11, 2015.(MOST 104-2221-E-167-007)",
          path: "",
        },

        {
          num: "(LC24).",
          name: "林宗宏、施諭廷 (2015),",
          ca: "“一種使用異質通道隨身存放直方圖訊息的新思維“",
          num2: ", in Proceedings of the 10th Conference Intelligent Living Technology Conference, (ILT2015) (ISBN:978-957-21-9894-0),",
          cal: "Taichung, Taiwan, pp.1051-1054, June. 05, 2015.(MOST 104-2221-E-167-007)",
          path: "",
        },

        {
          num: "(LC23).",
          name: "林宗宏、施諭廷、林琮皓 (2015),",
          ca: "“一種 ShiVa3D APP 遊戲智慧財產嵌入研究“",
          num2: ", in Proceedings of the 10th Conference Intelligent Living Technology Conference, (ILT2015) (ISBN:978-957-21-9894-0),",
          cal: "Taichung, Taiwan, pp.1042-1045, June. 05, 2015. (NSC 102-2815-C-167-009-E)",
          path: "",
        },

        {
          num: "(LC22).",
          name: "林宗宏、方宇嘉 (2015),",
          ca: "“軌跡辨識於密碼辨識之應用“",
          num2: ", in Proceedings of the 10th Conference Intelligent Living Technology Conference, (ILT2015) (ISBN:978-957-21-9894-0),",
          cal: "Taichung, Taiwan, pp.1055-1058, June. 05, 2015.",
          path: "",
        },

        {
          num: "(LC21).",
          name: "林宗宏*、楊閔盛 (2014),",
          ca: "“一個高壓縮率的異質通道資訊隱藏技術“",
          num2: ", in Proceedings of the 9th Conference Intelligent Living Technology Conference, (ILT2014) (ISBN: 978-957-21-9400-3),",
          cal: "Taichung, Taiwan, June. 6, 2014.",
          path: "",
        },

        {
          num: "(LC20).",
          name: "林宗宏*、林源忠 (2014),",
          ca: "“一個基於混沌系統以識別碼為基礎的遠端認證系統弱點分析與改善”",
          num2: ", in Proceedings of the 9th Conference Intelligent Living Technology Conference, (ILT2014) (ISBN: 978-957-21-9400-3),",
          cal: "Taichung, Taiwan, June. 6, 2014.",
          path: "",
        },

        {
          num: "(LC19).",
          name: "林宗宏*、張家豪、王其能 (2014),",
          ca: "“不同碰撞偵測方法對轉珠遊戲之影響與探討“",
          num2: ", in Proceedings of the 9th Conference Intelligent Living Technology Conference, (ILT2014) (ISBN: 978-957-21-9400-3),",
          cal: "Taichung, Taiwan, June. 6, 2014.",
          path: "",
        },

        {
          num: "(LC18).",
          name: "林宗宏*、施諭廷、陳奕兆 (2014),",
          ca: "“利用MVC架構進行遊戲狀態整合設計“",
          num2: ", in Proceedings of the 9th Conference Intelligent Living Technology Conference, (ILT2014) (ISBN: 978-957-21-9400-3) ,",
          cal: "Taichung, Taiwan, June. 6, 2014.",
          path: "",
        },

        {
          num: "(LC17).",
          name: "林宗宏*、王曾柏、楊凱傑 (2014),",
          ca: "“不規則遊戲物件之碰撞偵測研究“",
          num2: ", in Proceedings of the 9th Conference Intelligent Living Technology Conference, (ILT2014) (ISBN: 978-957-21-9400-3),",
          cal: "Taichung, Taiwan, June. 6, 2014.",
          path: "",
        },

        {
          num: "(LC16).",
          name: "林宗宏*、鄭弘昇 (2013),",
          ca: "“使用FPGA 動態高效支援高解析度RGB介液晶顯示之實現“",
          num2: ", in Proceedings of the 2013 Conference on Innovative Electronics Design and Application, (IED2013) (ISBN: 978-957-21-9205-4),",
          cal: "Taichung, Taiwan, pp.162-168, Dec. 13, 2013.",
          path: "",
        },

        {
          num: "(LC15).",
          name: "林宗宏*、陳煥文 (2013),",
          ca: "“面板觸控模組ITO電路走線短路之綠能高效即時預檢設計“",
          num2: ", in Proceedings of the 2013 Conference on Innovative Electronics Design and Application, (IED2013) (ISBN: 978-957-21-9205-4),",
          cal: "Taichung, Taiwan, pp.370-373, Dec. 13, 2013.",
          path: "",
        },

        {
          num: "(LC14).",
          name: "林宗宏*、陳威宇、游志男、莊侑錡 (2012),",
          ca: "“一種創新即時手持裝置地圖應用顯示系統”",
          num2: ", in Proceedings of the 2nd Conference on Applications of Innovation and Invention, (AII2012) (ISBN: 978-957-21-8725-8),",
          cal: "Taichung, Taiwan, pp.704-707, Nov. 23, 2012. (NSC-101-2815-C-167-014-E)",
          path: "",
        },

        {
          num: "(LC13).",
          name: "林宗宏*、施諭廷、游志男、莊侑錡 (2012),",
          ca: "“一種於行動平台3D射擊遊戲程式設計新思維“",
          num2: ", in Proceedings of the 2nd Conference on Applications of Innovation and Invention, (AII2012) (ISBN: 978-957-21-8725-8),",
          cal: "Taichung, Taiwan, pp.271-275, Nov. 23, 2012. (NSC-101-2815-C-167-014-E)",
          path: "",
        },

        {
          num: "(LC12).",
          name: "林宗宏*、游志男、林家鴻、莊侑錡 (2012),",
          ca: "“行動平台3D遊戲人物移動程式設計技巧“",
          num2: ", in Proceedings of the 2nd Conference on Applications of Innovation and Invention, (AII2012) (ISBN: 978-957-21-8725-8),",
          cal: "Taichung, Taiwan, pp.265-270, Nov. 23, 2012. (NSC-101-2815-C-167-014-E)",
          path: "",
        },

        {
          num: "(LC11).",
          name: "林宗宏*、陳威宇、游志男、莊侑錡 (2012),",
          ca: "“跨平台手機多媒體遊戲設計–以ShiVa3D實作為例“",
          num2: ", in Proceedings of the Seventh Intelligent Living Technology Conference (ILT2012)(ISBN: 978-957-21-8506-3),",
          cal: "Taichung, Taiwan, June 1, 2012.",
          path: "",
        },

        {
          num: "(LC10).",
          name: "林宗宏*、徐子恩、吳恒緯 (2012),",
          ca: "“互動語音聲控汽車動點即時追蹤導引系統“",
          num2: ", in Proceedings of the 4th Cross-Strait Technology, Humanity Education and Academy-Industry Cooperation Conference (THE2010),",
          cal: "Taichung, Taiwan, Dec. 2, 2010.",
          path: "",
        },

        {
          num: "(LC09).",
          name: "林胤忱、林宗宏、林基源、王俊傑、黃喻翔 (2010),",
          ca: "“二維Hamming糾錯碼與DES密碼技術於醫學影像通訊傳輸之應用“",
          num2: ", in Proceedings of the Fifth Intelligent Living Technology Conference (ILT2010)(ISBN: 978-957-21-7647-4),",
          cal: "Taichung, Taiwan, June 4, 2010.",
          path: "",
        },

        {
          num: "(LC08).",
          name: "林宗宏*、鍾翰 (2009),",
          ca: "“結合簡訊驗證之綠色數位行動快遞簽收助理“",
          num2: ", in Proceedings of the 2009 Workshop on Consumer Electronics (WCE2009),",
          cal: "Taichung, Taiwan, pp. 373-378, Nov. 06, 2009.",
          path: "",
        },

        {
          num: "(LC07).",
          name: "林宗宏*、何奇紘、洪向澤 (2009),",
          ca: "“無線多層次聲控點播系統“",
          num2: ", in Proceedings of the Fourth Intelligent Living Technology Conference (ILT2009)(ISBN: 978-957-21-7031-1),",
          cal: "Taichung, Taiwan, June 5, 2009.",
          path: "",
        },

        {
          num: "(LC06).",
          name: "林宗宏*、吳恒緯、林育如 (2009),",
          ca: "“無鎖孔生物辨識無線門禁感測監控系統“",
          num2: ", in Proceedings of the Fourth Intelligent Living Technology Conference (ILT2009)(ISBN: 978-957-21-7031-1),",
          cal: "Taichung, Taiwan, June 5, 2009.",
          path: "",
        },

        {
          num: "(LC05).",
          name: "林宗宏*、黃信衡 (2008),",
          ca: "“無表格資訊隱藏之安全傳輸圖形化密碼驗證系統“",
          num2: ", in Proceedings of the 2nd Cross-Strait Technology, Humanity Education and Academy-Industry Cooperation Conference (2008THE),",
          cal: "pp.684-690, Taichung, Taiwan, Dec. 4-5, 2008.",
          path: "",
        },

        {
          num: "(LC04).",
          name: "林宗宏*、吳恒緯、林基源 (2008),",
          ca: " “一個安全的簽名筆跡資訊隱藏密碼驗證系統系統“",
          num2: ", in Proceedings of the 2nd Cross-Strait Technology, Humanity Education and Academy-Industry Cooperation Conference (2008THE),",
          cal: "pp.757-763, Taichung, Taiwan, Dec. 4-5, 2008.",
          path: "",
        },

        {
          num: "(LC03).",
          name: "林宗宏*、劉宏偉、李文耀、陳瑞茂 (2008),",
          ca: "“以叢聚樹拓樸特性建構高效能ZigBee網路新架構“",
          num2: ", in Proceedings of the 2nd Cross-Strait Technology, Humanity Education and Academy-Industry Cooperation Conference (2008THE),",
          cal: "pp.657-664, Taichung, Taiwan, Dec. 4-5, 2008.",
          path: "",
        },

        {
          num: "(LC02).",
          name: "林宗宏*、賴彥宏、張蓺英、李文耀 (2008),",
          ca: "“即時性動態環境監測系統–實作ZigBee溫度感測網路“",
          num2: ", in Proceedings of the 2nd Cross-Strait Technology, Humanity Education and Academy-Industry Cooperation Conference (2008THE),",
          cal: "pp.670-675, Taichung, Taiwan, Dec. 4-5, 2008.",
          path: "",
        },

        {
          num: "(LC01).",
          name: "劉紹漢、林灶生、黃世演、林宗宏 (2007),",
          ca: "“植基於退火粒子群最佳演算法之奇異質分解於二維濾波器之設計“",
          num2: ", 第一屆海峽兩岸工程科技教育與產學合作研討會, 江蘇常州, pp. 27-31, 12月, 2007.",
          cal: "",
          path: "",
        },
      ],
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@font-face {
  font-family: "NotoSansTC_Regular";
  src: url("../assets/font/NotoSansTC-Regular.otf") format("truetype");
}
@font-face {
  font-family: "NotoSansTC_Bold";
  src: url("../assets/font/NotoSansTC-Bold.otf") format("truetype");
}

/*--------------------------------------------------------------
# General
--------------------------------------------------------------*/
body {
  font-family: "NotoSansTC_Regular", sans-serif;
  color: #777;
}

a {
  text-decoration: none;
  color: #43aea0;
  cursor: pointer;
}

a:hover {
  color: #00d3b8;
  text-decoration: none;
}

h1,
h2,
h3,
h4,
h5,
h6,
.ct1 {
  color: rgb(103, 38, 146);
}
.ct2 {
  color: blue;
}
.ct3 {
  color: coral;
}
.ct4 {
  color: red;
}
.ct5 {
  color: rgb(4, 174, 173);
}
.font-primary {
  font-family: "NotoSansTC_Regular", sans-serif;
}

/*--------------------------------------------------------------
# Sections General
--------------------------------------------------------------*/
section {
  padding: 100px;
}

.section-bg {
  background-color: #f2f9f8;
}

.section-title {
  font-family: "NotoSansTC_Bold";
  text-align: center;
  padding-bottom: 30px;
}
.section-title h2 {
  font-size: 32px;
  font-weight: 300;
  margin-bottom: 20px;
  padding-bottom: 0;
  color: #555;
}
.section-title p {
  margin-bottom: 0;
}

/*--------------------------------------------------------------
# publicaiton
--------------------------------------------------------------*/
.publicaiton-title {
  font-family: "NotoSansTC_Bold";
  color: #000000;
  font-size: 3vh;
  text-align: center;
}
.publicaiton-content {
  font-family: "NotoSansTC_Regular";
  font-size: 2vh;
  text-align: left;
  color: #065654;
}

.about h3 {
  font-weight: 400;
  font-size: 26px;
}
.about ul {
  list-style: none;
  padding: 0;
}
.about ul li {
  padding-bottom: 10px;
}
.about ul i {
  font-size: 22px;
  padding-right: 4px;
  color: #70b9b0;
  line-height: 0;
}
.about p {
  text-align: left;
  margin-bottom: 0;
}
</style>
